
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import AuthMixin from '~/mixins/authMixin'

import { Team, TeamConnection, User } from '~/types/types'
import { resolveNodes } from '~/utils/array'

type AliasedUser = User & { primaryTeamAccounts: TeamConnection }

export default defineComponent({
  name: 'DeleteUser',
  mixins: [ActiveUserMixin, AuthMixin],
  data() {
    return {
      chevronIconAnimateClass: '',
      showDeleteDialog: false,
      deleteStep: 0, // 0 = initial dialog with warning message, 1 = email input step with actual delete button
      deletingUser: false,
      typedEmail: '',
      emailIsValid: true
    }
  },
  computed: {
    teamOwnerships(): Team[] {
      return resolveNodes((this.viewer as AliasedUser).primaryTeamAccounts)
    },
    deleteAllowed(): boolean {
      return this.teamOwnerships.length === 0
    }
  },
  methods: {
    validateEmail(): void {
      const emailInput = this.$refs['emailInput'] as HTMLInputElement
      emailInput.value = this.typedEmail
      this.emailIsValid = emailInput.checkValidity()
    },
    teamSettingsLink(team: Team): string {
      return `/${team.vcsProvider.toLowerCase()}/${team.login}/members/active`
    },
    handleDialogClose(): void {
      this.showDeleteDialog = false
      this.deleteStep = 0
    },
    async handleDeleteUser(): Promise<boolean> {
      if (this.typedEmail !== this.viewer.email) {
        this.$toast.danger('The typed email does not match your account email address!')
        return false
      }
      this.deletingUser = true
      const response = await this.deleteUser({
        sendEmail: true
      })
      this.deletingUser = false
      if (response === true) {
        window.location.replace('/user-deleted')
      }
      return false
    },
    isOpenHandler(open: boolean): void {
      this.chevronIconAnimateClass = open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
    }
  }
})
